import { render, staticRenderFns } from "./imgcode_dialog.vue?vue&type=template&id=1006d53e"
import script from "./imgcode_dialog.vue?vue&type=script&lang=js"
export * from "./imgcode_dialog.vue?vue&type=script&lang=js"
import style0 from "./imgcode_dialog.vue?vue&type=style&index=0&id=1006d53e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports